
export type DeleteUser403 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
